function MessagesTab({ messages, onMarkRead, onDelete }) {
    return (
        <div className="admin__section">
            <table className="admin__table">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Nume</th>
                        <th>Email</th>
                        <th>Subiect</th>
                        <th>Mesaj</th>
                        <th>Status</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {messages.map((m) => {
                        const isRead = parseInt(m.is_read) === 1;
                        return (
                            <tr key={m.id} className={isRead ? "" : "unread"}>
                                <td>{new Date(m.created_at).toLocaleString("ro-RO")}</td>
                                <td>{m.name}</td>
                                <td>
                                    <a href={`mailto:${m.email}`}>{m.email}</a>
                                </td>
                                <td>{m.subject || "-"}</td>
                                <td className="admin__message-text">{m.message}</td>
                                <td>{isRead ? "Citit" : "Necitit"}</td>
                                <td>
                                    {!isRead && <button onClick={() => onMarkRead(m.id)}>Marchează citit</button>}
                                    <button onClick={() => onDelete(m.id)} className="delete">
                                        Șterge
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default MessagesTab;
